import { ReactNode } from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'

// Components
import { Link, Pill } from '@tracklib/kit'

// Selectors
import { selectAll, ownCollectionsSelector } from 'selectors'

// Types
import { Collection } from 'types'

import styles from './menu.css'

export const Label = ({ children }: { children: ReactNode }) => (
  <Pill size="small" className={styles.label}>
    {children}
  </Pill>
)

const isActive = (url: string, detail: string | null, pathname: string, ownCollectionIds: Array<Collection>) => {
  return (
    pathname.startsWith(url) ||
    (detail &&
      pathname.startsWith(detail) &&
      !ownCollectionIds.find(id => {
        // Don't return true if page is an owned collection since they have their own active styling in sidebar
        return pathname.startsWith('/collection') && pathname.replace('/collection/', '').startsWith(String(id))
      }))
  )
}

type MenuProps = {
  location: Location
  ownCollectionIds: Array<Collection>
}

const Menu = ({ location, ownCollectionIds }: MenuProps): JSX.Element => (
  <ul className={styles.menu}>
    {[
      { text: 'Inspiration', url: '/inspiration/', detail: null },
      { text: 'All tracks', url: '/tracks/', detail: '/song/' },
      { text: 'Collections', url: '/collections/', detail: '/collection/' },
      { text: 'Genres', url: '/genres/', detail: '/genre/' },
      { text: 'Artists', url: '/artists/', detail: '/artist/' },
      { text: 'Labels', url: '/labels/', detail: '/label/' },
    ].map(x => {
      const active = isActive(x.url, x.detail, location.pathname, ownCollectionIds)
      return (
        <li key={x.url}>
          <Link className={active ? styles.linkActive : styles.link} to={x.url}>
            {x.text}
          </Link>
        </li>
      )
    })}
  </ul>
)

const mapStateToProps = createSelector([selectAll, ownCollectionsSelector], (state, ownCollections) => {
  return {
    ownCollectionIds: ownCollections.map(({ id }) => id),
    location: state.router.location,
  }
})
export default connect(mapStateToProps)(Menu)
